// extracted by mini-css-extract-plugin
module.exports = {"section":"country-selector-module__section___3Uuo2"};